import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './ProgramCollectionItemSkeleton.styles';

const ProgramCollectionItemSkeleton = () => {
  const theme = useTheme();

  const { classes } = useStyles(theme);

  return (
    <div className={classes.wrapper}>
      <Box className={classes.header}>
        <Skeleton
          variant="circular"
          className={classes.avatarSkeleton}
          width={32}
          height={32}
        />
        <Skeleton
          variant="text"
          className={classes.titleSkeleton}
          height={22}
          width="60%"
        />
      </Box>
      <Box className={classes.iconsBlock}>
        <Skeleton
          variant="circular"
          className={classes.iconSkeleton}
          width={24}
          height={24}
        />
        <Skeleton
          variant="circular"
          className={classes.iconSkeleton}
          width={24}
          height={24}
        />
      </Box>
    </div>
  );
};

export default ProgramCollectionItemSkeleton;
